export default __webpack_public_path__ + "static/media/delete.fea87e0c.svg";